/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card, Container, LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TestBody from '../../PlacementTest/components/TestBody';
import TestFinishedOtherLanguage from './TestFinishedOtherLanguage';
import placementTestServices from '../../../redux/services/placementTestServices';
import LandingTestOther from './LandingTestOther';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    marginTop: theme.spacing(1),
    position: 'relative',
  },
  progressBar: {
    width: '100%',
    height: '5px',
  },
}));

const PlacementTestOtherLanguage = ({
  test, currentQuestion, answers, language, _id,
}) => {
  const [testDone, setTestDone] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    placementTestServices.getTestByLanguage(_id, language)
      .then((res) => {
        if (res && res.scores && res.answers.length === 60) {
          setTestDone(true);
        }
      })
      .catch();
  }, []);

  return testDone ? (<Redirect to="/home" />) : (
    <>
      <Container>
        <Card variant="outlined" className={classes.root}>
          {test ? (
            (currentQuestion === test.questions.length) ? (
              <TestFinishedOtherLanguage testId={test.testId} answers={answers} />
            ) : (
              <>
                <TestBody
                  descriptionRC={test.descriptionRC}
                  descriptionOC={test.descriptionOC}
                  descriptionKN={test.descriptionKN}
                  testData={test.questions}
                />
                <LinearProgress
                  className={classes.progressBar}
                  variant="determinate"
                  value={test ? ((currentQuestion / test.questions.length) * 100) : 0}
                />
              </>
            )
          ) : (
            <LandingTestOther />
          )}
        </Card>
      </Container>
    </>
  );
};

PlacementTestOtherLanguage.propTypes = {
  test: PropTypes.object.isRequired,
  currentQuestion: PropTypes.number.isRequired,
  answers: PropTypes.array.isRequired,
};

function mapState(state) {
  const { auth, isTest } = state.authentication;
  const { language } = state.language;
  const {
    requestingTest, test, answers, currentQuestion,
  } = state.placementTest;
  const { _id, code } = auth;
  return {
    language,
    code,
    _id,
    requestingTest,
    test,
    isTest,
    answers,
    currentQuestion,
    auth,
  };
}
export default connect(mapState)(PlacementTestOtherLanguage);
